/* eslint-disable @typescript-eslint/no-explicit-any */
import { asyncComponent } from '@tock/shared/utils/asyncComponent';
import interactivePromise from '@tock/shared/utils/interactivePromise';

const ConfirmAction = asyncComponent(() => import('shared/components/modals/ConfirmAction'));

export interface ConfirmOptions {
  cancelText?: string;
  continueText?: string;
  isDestructive?: boolean;
  title?: string;
  hideCancelButton?: boolean;
}

/**
 * @deprecated succeeded by asyncRender (dashboard), no usage in consumer, ok in clowncar
 *
 * - [Migration Guide](https://github.com/tocktix/admin/wiki/Dashboard-confirm-migration-guide)
 */
const confirm = {
  onTransition(text: any) {
    return confirm.show(text);
  },

  show(text: any, options: ConfirmOptions = {}) {
    const props = {
      cancelText: options.cancelText,
      continueText: options.continueText,
      isDestructive: options.isDestructive,
      text,
      title: options.title,
      hideCancelButton: options.hideCancelButton,
    };

    return interactivePromise((resolve, reject) => (
      <ConfirmAction
        cancelText={props.cancelText}
        continueText={props.continueText}
        isDestructive={props.isDestructive}
        onCancel={reject}
        onContinue={resolve}
        text={props.text}
        title={props.title}
        hideCancelButton={props.hideCancelButton}
      />
    ));
  },
};

export default confirm;
